
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/business-division/[slug]",
      function () {
        return require("private-next-pages/[locale]/business-division/[slug].page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/business-division/[slug]"])
      });
    }
  